// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:36:35

export default {
  "id": "jigsort-puzzles",
  "slug": "jigsort-puzzles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9247f50627704d538ee7288c2ad68531-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9247f50627704d538ee7288c2ad68531/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jigsort Puzzles",
      "description": "Jigsort Puzzle is an app that is art puzzle and lets you complete jigsaw puzzle game for free! Various difficulty levels for casual and experiences puzzlers!",
      "instructions": "Swap the puzzle to correct position",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2d"
      ]
    },
    "zh-CN": {
      "title": "奇排序拼图",
      "description": "Jigsort Puzzle 是一款艺术拼图应用，让您免费完成拼图游戏！提供各种难度级别，适合休闲玩家和经验丰富的解谜者！",
      "instructions": "交换拼图至正确位置",
      "genres": [
        "拼图"
      ],
      "tags": [
        "二维"
      ]
    },
    "zh-TW": {
      "title": "奇巧排序謎題",
      "description": "Jigsort Puzzle 是一款藝術拼圖應用程式，讓您可以免費完成拼圖遊戲！提供各種難度等級，適合休闲玩家和經驗豐富的拼圖愛好者！",
      "instructions": "交換謎題至正確位置",
      "genres": [
        "謎題"
      ],
      "tags": [
        "二維"
      ]
    },
    "zh-HK": {
      "title": "奇序謎題",
      "description": "Jigsort Puzzle 是一款藝術拼圖應用程式，讓你可以免費完成拼圖遊戲！提供各種難度等級，適合輕鬆玩家和經驗豐富的拼圖愛好者！",
      "instructions": "交換謎題至正確位置",
      "genres": [
        "謎題"
      ],
      "tags": [
        "二維"
      ]
    },
    "ja": {
      "title": "ジグソートパズル",
      "description": "ジグソートパズルは、アートパズルで無料でジグソーパズルゲームを楽しむことができるアプリです！カジュアルからエキスパートまで、様々な難易度レベルがあります！",
      "instructions": "パズルを正しい位置に交換してください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "2D"
      ]
    },
    "ko": {
      "title": "지거트 스티어드 패즈",
      "description": "Jigsort Puzzle는 예술 퍼즐 앱으로, 무료로 조각 퍼즐 게임을 완료할 수 있습니다! 캐주얼한 및 경험 많은 퍼즐 해결자들을 위한 다양한 난이도 수준!",
      "instructions": "퍼즐을 올바른 위치로 바꾸세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "2D"
      ]
    },
    "fr": {
      "title": "Jigsort Puzzles",
      "description": "Jigsort Puzzle est une application qui est un puzzle artistique et vous permet de terminer des jeux de puzzle en puzzle gratuitement ! Différents niveaux de difficulté pour les joueurs occasionnels et expérimentés !",
      "instructions": "Échangez le puzzle pour le positionner correctement",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2D"
      ]
    }
  }
};
